import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Header, Footer } from "@/components/Layout";
import { track } from "@/lib/api";
import HomePage from "@/pages/HomePage";
import SeoLandingPage from "@/pages/SeoLandingPage";
import DatenschutzPage from "@/pages/DatenschutzPage";
import ImpressumPage from "@/pages/ImpressumPage";

function PageViewTracker() {
  useEffect(() => {
    track("page_view", { path: window.location.pathname });
  }, []);
  return null;
}

function App() {
  return (
    <div className="App app-noise">
      <BrowserRouter>
        <PageViewTracker />
        <Header />
        <main className="relative z-10">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/kleinanzeigen-text-aus-foto" element={<HomePage />} />
            <Route path="/datenschutz" element={<DatenschutzPage />} />
            <Route path="/impressum" element={<ImpressumPage />} />
            <Route path="/:seoSlug" element={<SeoLandingPage />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
